export default function reportTypesDirective() {
  return {
    template: require('./report-types.html'),
    controller: 'GRReportTypesController',
    controllerAs: 'grReportTypesVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportTypes: '=',
    },
  };
}
